export const formatNumber = ({ value, locale = 'en-US', percent = false, precision = 2, options = {} }: any) => {
  let enhancedOptions = {
    ...options,
    maximumFractionDigits: precision,
  };

  if (!value && typeof value !== 'number') {
    return '-';
  }

  if (percent) {
    enhancedOptions = {
      ...enhancedOptions,
      style: 'percent',
    };
  }

  return value.toLocaleString(locale, enhancedOptions);
};
export const formatCurrency = ({
  value,
  locale = 'en-US',
  precision = 0,
  compact = false,
  currency,
}: {
  value: number;
  locale?: string;
  precision?: number;
  compact?: boolean;
  currency?: string;
}) => {
  return (value || 0)
    .toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: precision,
      style: 'currency',
      unitDisplay: 'narrow',
      currency: currency || (locale === 'fr' ? 'EUR' : 'USD'),
      ...(compact ? { notation: 'compact', compactDisplay: 'short' } : {}),
    })
    .replace(/\Dk.*€/, 'k€')
    .replace(/\Dk.*\$/, 'k$');
};

export const formatSize = (bytes?: number | React.ReactNode) => {
  if (typeof bytes !== 'number') {
    return { value: bytes, unit: 'MB', string: `${bytes} MB` };
  }

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0 || !bytes) return { value: 0, unit: 'Byte', string: '0 Byte' };
  const i = parseInt(`${Math.floor(Math.log(bytes) / Math.log(1024))}`, 10);
  const value = parseFloat((bytes / Math.pow(1024, i)).toFixed(2));
  const unit = sizes[i];
  return { value, unit, string: value + ' ' + unit };
};
